// extracted by mini-css-extract-plugin
export const building101 = "building101-module--building-101--1gsm1";